import React, { Component } from 'react'
import { Field, reduxForm, change } from 'redux-form';
import { connect } from 'react-redux'
import { Link } from "react-router-dom"
import classNames from 'classnames';
import $ from 'jquery';
import agent from '../agent'
import moment from 'moment'
import QRCode from 'qrcode-react';
import Footer from '../components/company/footer';
//import {InlineShareButtons} from 'sharethis-reactjs';

import closeLight from '../assets/images/close-light.png'
import closeDark from '../assets/images/close-dark.png'
import project1 from '../assets/images/mickey.jpg'
import companyLogo from '../assets/images/LifeChurchMedia-Logo_White.png'
import companyLogoBlack from '../assets/images/LifeChurchMedia-Logo_Black.png'
import amlogo from '../assets/images/company-client-landing-page-auditionmagiciconplain@2x.png'

import project_details_logo1 from '../assets/images/expanded-project-shape-4@2x.png'
import project_details_logo1_dark from '../assets/images/expanded-project-responsive-shape-4@2x.png'
import project_details_logo2 from '../assets/images/check-in-expanded-01-copy-10-shape-5@2x.png'
import project_details_logo2_dark from '../assets/images/expanded-project-responsive-shape-5@2x.png'
import project_details_logo3 from '../assets/images/expanded-project-shape-6@2x.png'
import project_details_logo3_dark from '../assets/images/expanded-project-responsive-shape-6@2x.png'
import project_details_logo4 from '../assets/images/check-in-expanded-01-copy-10-shape-7@2x.png'
import project_details_logo4_dark from '../assets/images/expanded-project-responsive-shape-7@2x.png'
import project_details_logo5 from '../assets/images/expanded-project-shape-8@2x.png'
import project_details_logo5_dark from '../assets/images/expanded-project-responsive-shape-8@2x.png'
import project_details_logo6 from '../assets/images/check-in-expanded-01-copy-10-path-6@2x.png'
import project_details_logo7 from '../assets/images/check-in-expanded-01-copy-10-shape-9@2x.png'
import project_details_logo8 from '../assets/images/check-in-expanded-01-copy-10-shape-10@2x.png'
import project_details_logo6_dark from '../assets/images/expanded-project-responsive-path-1@2x.png'
import project_details_logo7_dark from '../assets/images/company-landing-page--register-col-path@2x.png'

import social_media1 from '../assets/images/check-in-expanded-01-copy-9-path@2x.png'
import social_media2 from '../assets/images/expanded-project-responsive-path-3@2x.png'
import social_media3 from '../assets/images/expanded-project-shape@2x.png'
import social_media4 from '../assets/images/company-landing-page--register-path-2@2x.png'
import social_media5 from '../assets/images/expanded-project-path-3@2x.png'
import social_media6 from '../assets/images/check-in-expanded-01-copy-10-path-4@2x.png'
import social_media7 from '../assets/images/company-client-landing-page--expanded--review-path-5@2x.png'
import social_media8 from '../assets/images/check-in-expanded-01-copy-10-shape-1@2x.png'
import social_media9 from '../assets/images/company-client-landing-page--expanded--review-shape-2@2x.png'
import social_media10 from '../assets/images/check-in-expanded-01-copy-10-shape-3@2x.png'

import qrcode from '../assets/images/expanded-project-responsive-qr-code@2x.png'

class ProjectDetails extends Component {
	state = {
        register: 'button header-button-selected',
        checkin: 'button header-button-unselected',
        pagestate: '',
        theme: 'light',	//temporary
        share_flag: false,
        company_landing_theme: 'dark',
        scrollFlag: false,
        role: []
    }

    componentWillMount() {
    	agent.Project.getRoles(this.props.project.id).then((k) => {
	  		const role = k.roles.filter(k => k.project_id === this.props.project.id)
	  		role.map((item, i) => {
	  			// console.log('componentWillMount-projectdetails-roles', item.medium_ids)
	  			if (typeof item.medium_ids != 'undefined')
					item.medium_ids.map(item => this.props.onLoadRoleMedia(item))
	    	})
	    	this.setState({ role: role })
	  	})
    }

    dateFormat (date) {
	  	const fdate = moment(date).format("DD - MMM - YYYY")
	  	return fdate;
	  }

	toUpper(value) {
		const val = value ? value.toUpperCase() : '';
		return val;
	}

	render(){
		const fixDetails = {
			paddingTop: '2rem'
		}
		const leftAlign = {
			textAlign: 'left'
		}
		const { project, location, history, toggleDetails, openDetails, projects, pagestate } = this.props
		const role = { ...this.state.role, media: {...this.props.media} }
		
		return (
			project ?
			<div className="row main-wrapper" data-theme="dark">
					<div className="column">
						<div className="row project-wrapper">
							<div name="project_view" className="row project-list">
								<div className="row">
									<div className="column small-3 align-right">
										<div className="row">
											<div className="column large-3 align-right">
												<a onClick={e => openDetails("register", 0, projects)}>
												{
													this.state.company_landing_theme === 'dark' ?
													<img src={closeDark} width="75px" /> : 
													<img src={closeLight} width="75px" />
												}</a>
											</div>
										</div>
									</div>
									<div className="column project">
										<button className="large-5" type="button">
											<div className="project-border">
												<div className="img-holder-1">
													<div className="img-holder-sub-details-1">
														<img src={project.cover_url} />
													</div>
					                            </div>
					                            <div className="project-name2">{project.name}</div>
					                        </div>
				                            <div className="row">
				                            	<div className="column large-3 large-centered">
			                            			<div className="border arrow-down center-by-margin"></div>
					                            </div>
				                            </div>
				                        </button>
									</div>
								</div>
								<div className="row project-details-margin">
									<div className="large-11 large-centered column">
										<div className="row">
			                                <div className="large-8 column">
			                                    <div className="row project-details-title">{project.name}</div>
			                                    <div className="row project-details-desc">
			                                    	<pre className="text-style">{project.description}</pre>
			                                    </div>
			                                    <div className="row project-detail-list">
			                                    	{
				                                    	project.earliest_audition_date ?
					                                        <div className="detail-1">
					                                            <div className="detail-logo">
					                                            {
					                                            	this.state.company_landing_theme === 'dark' ?
					                                            		<img src={project_details_logo1_dark} className="shape"/> :
					                                                	<img src={project_details_logo1} className="shape"/>
					                                            }
					                                            </div>
					                                            <div className="detail-text">
				                                                	<div><b>NEXT AUDITIONS ON</b>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;{this.toUpper(this.dateFormat(project.earliest_audition_date))}</div>
					                                            </div>
					                                        </div> : <div></div>
				                                    }
				                                    {
				                                    	project.earliest_audition_location ?
					                                        <div className="detail-1">
					                                            <div className="detail-logo">
					                                            {
					                                            	this.state.company_landing_theme === 'dark' ?
					                                            		<img src={project_details_logo2_dark} className="shape" /> :
					                                                	<img src={project_details_logo2} className="shape" />
					                                            }
					                                            </div>
					                                            <div className="detail-text">
					                                                <div><b>AUDITIONING IN</b>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;{this.toUpper(project.earliest_audition_location)}</div>
					                                            </div>
					                                        </div> : <div></div>
			                                        }
			                                        <div className="detail-1 hide-content">
			                                            <div className="detail-logo">
			                                            {
			                                            	this.state.company_landing_theme === 'dark' ?
			                                            		<img src={project_details_logo3_dark} className="shape" /> :
			                                                	<img src={project_details_logo3} className="shape" />
			                                            }
			                                            </div>
			                                            <div className="detail-text">
			                                                NON UNION
			                                            </div>
			                                        </div>
			                                        <div className="detail-1">
			                                            <div className="detail-logo">
			                                            {
			                                            	this.state.company_landing_theme === 'dark' ?
			                                            		<img src={project_details_logo4_dark} className="shape" /> :
			                                                	<img src={project_details_logo4} className="shape" />
			                                            }
			                                            </div>
			                                            <div className="detail-text">
			                                            {
			                                            	project.roles_count ?
			                                                	<div><b>SEEKING</b>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;{this.state.role.length} ROLES</div> :
			                                                	<b>ALL ROLES HAVE BEEN FULFILLED</b>
			                                            }
			                                            </div>
			                                        </div>
			                                        <div style={fixDetails} className="detail-1">
			                                        {
			                                        	this.state.role.map((role, index) => {
			                                        		return (
			                                        			<div key={index + 1} className="row base-roles">
					                                        		<div style={leftAlign} className="column medium-8">
					                                        			<div className="row">
					                                        				<div className="column">
					                                        					<b>{role.name}&nbsp;&nbsp;|&nbsp;&nbsp;
					                                        					{role.category}&nbsp;&nbsp;|&nbsp;&nbsp;
					                                        					{role.gender}&nbsp;&nbsp;|&nbsp;&nbsp;
					                                        					{role.age_from}&nbsp;-&nbsp;{role.age_to}</b>
					                                        				</div>
					                                        			</div>
					                                        			<div style={fixDetails} className="row">
					                                        				<div className="column">
					                                        				<pre className="text-style">{role.description}</pre>
					                                        				</div>
					                                        			</div>
					                                        		</div>
					                                        		{
					                                        			typeof role.medium_ids != 'undefined' ?
						                                        		<div className="column medium-4">
						                                        			<div className="row">
						                                        				<div className="column">
						                                        					<div className="row">
							                                        					<i className="column small-5 text-right fa fa-link" aria-hidden="true"></i>
							                                        					<p className="column small-7 text-left end"><b>FILES</b></p>
						                                        					</div>
						                                        				</div>
						                                        				<div className="column">
						                                        					<a href={role.media.url} target="_blank">{role.media.filename}</a>
						                                        				</div>
						                                        			</div>
						                                        		</div> : <div></div>
					                                        		}
					                                        	</div>
			                                        			)
			                                        	})
			                                        }
			                                        </div>
			                                        <div className="detail-1 hide-content">
			                                            <div className="detail-logo">
			                                            {
			                                            	this.state.company_landing_theme === 'dark' ?
			                                                	<img src={project_details_logo5_dark} className="shape" /> :
			                                                	<img src={project_details_logo5} className="shape" />
			                                            }
			                                            </div>
			                                            <div className="detail-text">
			                                                SHOOTING&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;23 MAR 2019&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;LOS ANGELES, USA
			                                            </div>
			                                        </div>
			                                        {
			                                        	pagestate === 'checkin' ?
					                                        <div className="detail-1">
					                                        	{
					                                        		this.state.company_landing_theme === 'dark' ?
							                                            <div className="detail-lock">
							                                                <img src={project_details_logo6_dark} className="path" />
							                                                <img src={project_details_logo7_dark} className="shape" />
							                                                <img src={project_details_logo8} className="shape1" />
							                                            </div> : 
							                                            <div className="detail-lock">
							                                            	<img src={project_details_logo6} className="path" />
							                                                <img src={project_details_logo7} className="shape" />
							                                                <img src={project_details_logo8} className="shape1" />
							                                            </div>
					                                            }
					                                            <div className="detail-text-1">
					                                                <b>ACCEPTING NEW TALENT (NOT ALREADY SCHEDULED)</b>
					                                            </div>
					                                        </div> : <div></div>
			                                        }
			                                    </div>
			                                </div>
			                                <div className="large-3 column padding-on-top">
			                                    <div className="row qrcode-area">
			                                    	<div className="column small-12 align-right">
				                                        <div className="row">
				                                            {
				                                            	//<img src={qrcode} className="qrcode" width="165px" />
				                                            	//project && <QRCode value={`${window.location.origin}/artist/login?project=${project.id}`} size={165} logo={amlogo} />
				                                            }
				                                        </div>
				                                        <div className="row add-padding">
				                                        {
				                                        	pagestate === 'register' ?
				                                        		project.pre_registration ?
					                                            <Link className="button 
					                                            	qrtext" 
					                                            	to={{
					                                            	pathname: '/apply',
					                                            	search: '?token=' + project.access_token,
					                                            	state: { 
																													artist: this.props.artistInfo, 
																													clientDetails: {
																												  		projectId: project
																											  		}
																												}
					                                            }} href="">SUBMIT MYSELF</Link> :
					                                          	<Link className="button 
					                                          		qrtext" to="#" disabled={true} 
					                                            	href="">APPLICATIONS CLOSED</Link> :
					                                        pagestate === 'checkin' ?
					                                            <Link className="button qrtext" to={{
					                                            	pathname: '/artist/login',
					                                            	search: '?project=' + project.id,
					                                            	// state: {
					                                            	// 	projectId: project.id
					                                            	// }
					                                            }} href="">CHECK-IN NOW</Link> : <div></div>
				                                        }
				                                        </div>
			                                        </div>
			                                    </div>
			                                </div>
		                                </div>
		                                <div className="row">
		                                {
		                                	this.state.share_flag ?
				                                <div className="large-6 column">
													<hr className="row details-line" />
				                                    <div className="row project-social-media">
				                                        <div className="column clear-padding">
				                                            <div className="row share">
				                                                Share
				                                            </div>
				                                            <div className="row social-media-desc">
				                                                Share project link on your social media
				                                            </div>
				                                            <div className="row small-12">
				                                            	<h1>Inline Share Buttons</h1>
														        
				                                            </div>
				                                        </div>
				                                    </div>
				                                </div> : <div></div>
			                            }
		                                </div>
	                                </div>
                            	</div>
							</div>
						</div>
						<Footer />
					</div>
			</div> : <div></div>
		)
	}
}

ProjectDetails = reduxForm({
  form: 'artistRegistrationWizard', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(ProjectDetails)

const mapStateToProps = state => ({
    media: state.projects.media ? state.projects.media : []
})


const mapDispatchToProps = (dispatch) => ({
  onLoadRoleMedia: (id) =>
        dispatch({ type: 'LOAD_ROLE_MEDIA', payload: agent.Project.getMedia(id) })
})

export default connect(mapStateToProps, mapDispatchToProps)(ProjectDetails)


// WEBPACK FOOTER //
// ./src/components/ProjectDetails.js